/* eslint-disable */
import axios from 'axios';
import { BASEURL } from "../helper/constant.js";

export default () => {
    const instance = axios.create({
        baseURL: BASEURL
    })
    if (localStorage.getItem('auth-token')) {
        instance.defaults.headers.common["authorization"] = `${localStorage.getItem('auth-token')}`;
    }
    instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

    instance.interceptors.response.use(
        function (response) {
            // return response;
            if (response.status !== 200) {
                // clearStorageAndRedirect();
            }
            return response;
        },
        function (error) {
            /* if (error.response.status != 200) {
                console.log("Your authorization token is invalid or expired");
                localStorage.clear();
                window.location.replace("/");
            }else if(error.response.status == 403){
                //Redirect to forbidden Page   
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                localStorage.clear();
                window.location.href="/";
            } */

            // clearStorageAndRedirect();
            return Promise.reject(error.response);
        }
    );

    const clearStorageAndRedirect = () => {
        localStorage.clear();
        window.location.replace('/');
    };
    
    return instance;
};